var Theme = Theme || {};

Theme.ToolboxEbook = (function ($) {

    return {
        downloadEbookChapterPage: _downloadEbookChapterPage
    };

    function _downloadEbookChapterPage() {
        $('.js-epub-download-link').on('click', function (e) {
            e.preventDefault();

            var epubFileDownloadLink = $(this).attr('href');
            var resourceId = $(this).data('parent-resource-id');
            var resourceTypeId = $(this).data('parent-resource-type');
            var multimediaType = $(this).data('multimedia-type');
            var accessCheckUrl = '/toolbox/CheckEpubDownloadAccess';
            var resourceData = { 'resourceId': resourceId, 'resourceTypeId': resourceTypeId, 'multimediaType': multimediaType };
            var guestAccessKeyFromDownloadLink = SCM.Common.getQueryStringValue(epubFileDownloadLink, 'guestAccessKey');
            if(SCM.Common.isDefined(guestAccessKeyFromDownloadLink)) {
                resourceData.guestAccessKey = guestAccessKeyFromDownloadLink;    
            }
            
            SCM.Ajax.post(accessCheckUrl, resourceData)
                .expectJson()
                .then(result => {
                    if (!result.AccessGranted) {
                        throw result?.AccessDeniedMessage ?? 'The PDF for this content cannot be accessed at this time.';
                    }

                    window.location = epubFileDownloadLink;
                })
                .catch(reason => {
                    var message = reason?.AccessDeniedMessage
                        ? reason.AccessDeniedMessage
                        : reason;

                    SCM.Modals.showModal(message);
                });
        });
    }

})(jQuery);